import { Idiomorph } from 'idiomorph';
import { isElement, snapshotFocus, restoreFocus } from './dom.js';

const PRESERVE_SELECTOR = '[data-morph-skip], .js-inpost-shipping-container';
const PAYMENT_SUBTREE_SELECTOR = '.js-payment-extra, .js-payment-form';

function shouldPreserve(node) {
  if (!isElement(node) || typeof node.matches !== 'function') {
    return false;
  }

  if (node.matches(PRESERVE_SELECTOR)) {
    return true;
  }

  return node.matches(PAYMENT_SUBTREE_SELECTOR) && node.querySelector('iframe') !== null;
}

function buildConfig(added, morphStyle) {
  return {
    morphStyle,
    callbacks: {
      beforeNodeMorphed(oldNode) {
        return !shouldPreserve(oldNode);
      },
      beforeNodeRemoved(node) {
        return !shouldPreserve(node);
      },
      afterNodeAdded(node) {
        if (isElement(node)) {
          added.push(node);
        }
      },
    },
  };
}

export function morphInner(container, html) {
  if (!container) {
    return [];
  }

  const added = [];
  const snapshot = snapshotFocus(container);

  Idiomorph.morph(container, html, buildConfig(added, 'innerHTML'));

  restoreFocus(snapshot, container);

  return added;
}

export function morphElement(element, html) {
  if (!element) {
    return [];
  }

  const added = [];
  const snapshot = snapshotFocus(document);

  Idiomorph.morph(element, html, buildConfig(added, 'outerHTML'));

  restoreFocus(snapshot, document);

  return added;
}
